
import {BIconEyeFill} from "bootstrap-vue";
import {parseProductDescription} from "kistenkonfigurator/build/util/parse-product-description";
import {compareNumber, toHtmlId} from "kistenkonfigurator/build/util/util";
import Vue, {PropType} from "vue";
import ProductPriceTable from "../../components/product/ProductPriceTable.vue";
import {ProductModelFactory} from "../../model/product/ProductModelFactory";
import {
  canBeConfigured,
  getExternalProductId,
  getProductOverviewImage,
  getProductUrl,
  toDefaultConfigurationObject,
} from "../../model/ProductBusinessLogic";
import {Product, ProductAttributeValueDTO, ProductDTO} from "../../model/rest/data-contracts";
import AddToCart from "../cart/AddToCart.vue";
import PriceDisplay from "./PriceDisplay.vue";
import ProductLink from "./ProductLink.vue";

export default Vue.extend({
  name: "ProductInOverview",
  components: {
    ProductPriceTable,
    ProductLink,
    PriceDisplay,
    AddToCart,
    BIconEyeFill,
  },
  props: {
    /** @type {Product} */
    product: {
      type: Object as PropType<ProductDTO>,
      default: () => ProductModelFactory.createEmptyOverviewProduct(),
      required: true,
    },
  },
  provide() {
    return {
      generateProductImage: () => this.productImageUrl,
    };
  },
  computed: {
    values(): Array<ProductAttributeValueDTO> {
      if (this.product.values == null) {
        return [];
      }
      return this.product.values
          // .filter((v: ProductAttributeValue) => isAttributeVisible(v.productAttribute.visibility, AttributeVisibility.PRODUCT_CONFIGURATOR)
          .filter(() => false)
          .sort((a: ProductAttributeValueDTO, b: ProductAttributeValueDTO) => compareNumber(a.productAttribute.sortOrder, b.productAttribute.sortOrder));
    },
    productImageAltText(): string {
      return this.product.name!;
    },
    isConfigurationProduct(): boolean {
      return canBeConfigured(this.product);
    },
    hasVolumeDiscount(): boolean {
      return !this.isConfigurationProduct && this.product.graduatedPrice != null ? this.product.graduatedPrice.length > 1 : false;
    },
    productImageUrl(): string {
      return getProductOverviewImage(this.$baseUrl(), this.product);
    },
    externalProductId(): string {
      const customerId = this.$auth.getCustomerId();
      const isAdmin = this.$auth.hasAdminPermission();
      return getExternalProductId(this.product, customerId, isAdmin).join(", ");
    },
  },
  methods: {
    getAnchorId(): string {
      return toHtmlId(this.product.name);
    },
    getProductUrl(): string {
      return getProductUrl(this as any, this.product, null);
    },
    getProductDescription(product: Product) {
      return parseProductDescription(toDefaultConfigurationObject(product), product.description);
    },
  },
});
